exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#users[data-v-1e169a02] {\n    margin: 12px;\n    margin-top: 36px;\n.top[data-v-1e169a02] {\n        margin-bottom: 12px;\n}\n.users[data-v-1e169a02] {\n\n        /*\n        .segment {\n            &:hover {\n                background-color: #f5f5f5;\n                cursor: pointer;\n            }\n        }\n*/\n.column[data-v-1e169a02] {\n            font-size: large;\n.main[data-v-1e169a02] {\n                font-weight: bold;\n                margin-top: 6px;\ni.icon[data-v-1e169a02] {\n                    margin-right: 20px;\n}\n}\n}\n}\n}\n", ""]);

// exports
